import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Pay from "@/pages/Pay";
import Plans from "@/pages/Plans";
import Member from "@/pages/Member";
import ChatWidget from "@/components/ChatWidget";

function ConditionalChatWidget() {
  const { pathname } = useLocation();
  if (pathname === "/admin" || pathname.startsWith("/admin/")) return null;
  if (pathname === "/member" || pathname.startsWith("/member/")) return null;
  return <ChatWidget />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/pay" element={<Pay />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/member" element={<Member />} />
          <Route path="/member/verify" element={<Member />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <ConditionalChatWidget />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
